import {
  configureStore,
  getDefaultMiddleware,
  combineReducers
} from '@reduxjs/toolkit';

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
//import storage from 'redux-persist/lib/storage';
import storage from 'redux-persist/lib/storage/session';
// middleware
import logger from 'redux-logger';

// ability to update default state
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

// encryption
import {encryptTransform} from 'redux-persist-transform-encrypt';


// Reducers
import eomReducer from './reducers/eomSlice';
import emarReducer from './reducers/emarSlice';
import patientReducer from './reducers/patientSlice';
import userReducer from './reducers/userSlice';
import returnsReducer from './reducers/returnsListSlice';
import barCodeReducer from './reducers/barCodeResultSlice';
import facilityReducer from './reducers/facilityListSlice';
import formReducer from './reducers/formsResultSlice';
import helperService from '../services/helper';
// browser fingerprint

// eslint-disable-next-line no-unused-vars
import ClientJS from 'clientjs';


// users fingerPrint
// client needed to initialize
//const client = new ClientJS();
const windowClient = new window.ClientJS();

// const fingerPrint = windowClient.getFingerprint()
let ua = windowClient.getBrowserData().ua;
let canvasPrint = windowClient.getCanvasPrint();

let fingerprint = windowClient.getCustomFingerprint(ua, canvasPrint);

// you want to remove some keys before you save
//const saveSubsetBlacklistFilter = createBlacklistFilter('', []);
// Persist config
const persistConfig = {
  key: 'main',
  storage,
  stateReconciler: autoMergeLevel2,
  transforms: [

    encryptTransform({
      // change this for production
      secretKey:
        ';+GBbmx,tqNjw1e&MhpiGx})G)0}%+' +
        fingerprint +
        'kefXFBcg+f$3=7(gXLNfP0IL[&4BywD;Qr',
      onError: function (error) {
        console.error(error);
      },
    }),
  ],
  blacklist: [],
};

// merge reducers
const reducers = combineReducers({
  eom: eomReducer,
  emar: emarReducer,
  patient: patientReducer,
  users: userReducer,
  returns: returnsReducer,
  barCodeResult: barCodeReducer,
  facilities:facilityReducer,
  expFormResult :formReducer
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    logger,
  ],
});

const onStoreInitialized = () => {
  const currentState = store.getState();
  const token = currentState.users?.user?.token;
  if (token) {
    helperService.setHeaders('Authorization', `Bearer ${token}`);
  }
  let key = currentState.users?.user?.salt;
  return key;
};

export const clearState = async () => {
  await persistor.purge();
  await persistor.purge();
  persistor.pause();
  persistor.flush().then(() => {
    return persistor.purge();
  });
  store.dispatch({
    type: 'RESET'
  });
  console.log('LOGOUT SUCCESSFUL');
  setTimeout(async () => await persistor.purge(), 2000);
};


export let persistor = persistStore(store, null, onStoreInitialized);
